import { category as categoryIcon } from "assets/icons";
import styled from "@emotion/styled";
import {  Col, Form, Select, Spin } from "antd";
import { FC, useEffect, useState } from "react";
import {  GetMasterRetailType, MasterRetailTypeData } from "services/interface";
import { useGetRetailType } from "hooks/useMasterData";
import { useAppSelector } from "store";
import { useGetFactoryDataById } from "hooks/useFactory";

const { Option } = Select;

interface Option {
  value: string | number;
  label: string | number;
}

interface ProductRetailTypeCardProps {
  is_active?: boolean;
}

const ProductRetailTypeCard: FC<ProductRetailTypeCardProps> = ({ is_active }) => {
   const [reatilType, setRetailType] = useState<MasterRetailTypeData[]>([]);

   const { contact, profile } = useAppSelector((state) => state.auth);

   const { data, isLoading, isError, refetch } = useGetFactoryDataById(profile?.user.role.ref_id ?? "");

   // const { data, isLoading } = useGetCategory();
  //const { data, isLoading } = useGetRetailType();

  useEffect(() => {
    if (data) {
     //convert data.factory.department to array MasterRetailTypeData
      const retailTypeData: MasterRetailTypeData[] = [];

     data.factory.department.forEach((item) => {
      retailTypeData.push({
        id: item.id.toString(),
        description: item.name,
        remark: item.name,
        process_type: "",
        value: item.id.toString(),
        sort_index: item.id
      })
     })

     setRetailType(retailTypeData);
    }
   //console.log("data", data);
  }, [data]);

 // console.log("category", category);

  const children: React.ReactNode[] = [];

  reatilType.forEach((item) => {
    children.push(<Option key={item.id} id={item.id} >{item.description}</Option>);
  });


  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
      <WrapperAll>
        <SpanIcon>{categoryIcon}</SpanIcon>
        <FormWrapper>
          <Form.Item
            label="แผนก"
            name="retail_type"
            rules={[{ required: is_active, message: "กรุณาเลือกแผนก" }]}
          >
            <Select
             mode="multiple"
              showSearch
              placeholder="ประเภทแผนก"
              optionFilterProp="children"
              notFoundContent={isLoading ? <Spin size="small" /> : null}
              loading={isLoading}
            >
              {children}
            </Select>
          </Form.Item>
        </FormWrapper>
      </WrapperAll>
    </Col>
  );
};

export default ProductRetailTypeCard;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 0px 20px;
  border-radius: 8px;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 76px;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 8px;
`;
